import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MARKETING_ROUTES } from "@/marketing/routes";

import { BRAND_QUERIES } from "@/marketing/infrastructure/influencer/brand/utils/queries";

interface BrandSelectProps {
  value: string;
  onChange: (brandId: string) => void;
}

export function BrandSelect({ value, onChange }: BrandSelectProps) {
  const { data: brandList = [], isLoading } = useQuery(BRAND_QUERIES.list({ limit: 100 }));

  if (isLoading) {
    return (
      <select
        disabled
        aria-label="Brand"
        className="tw-h-9 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-text-sm tw-text-muted-foreground"
      >
        <option>Loading brands…</option>
      </select>
    );
  }

  if (brandList.length === 0) {
    return (
      <div className="tw-flex tw-items-center tw-gap-2">
        <select
          disabled
          aria-label="Brand"
          className="tw-h-9 tw-flex-1 tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-text-sm tw-text-muted-foreground"
        >
          <option>No brands yet</option>
        </select>
        <Link
          to={MARKETING_ROUTES.brandManager}
          className="tw-flex-shrink-0 tw-text-[11px] tw-text-primary tw-underline-offset-2 hover:tw-underline"
        >
          Create one →
        </Link>
      </div>
    );
  }

  return (
    <>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Brand"
        className="tw-h-9 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-text-sm"
      >
        <option value="">Select a brand…</option>
        {brandList.map((b) => (
          <option key={b.brandId} value={b.brandId}>
            {b.name}
          </option>
        ))}
      </select>
      <Link
        to={MARKETING_ROUTES.brandManager}
        target="_blank"
        className="tw-mt-1 tw-inline-block tw-text-[11px] tw-text-muted-foreground tw-underline-offset-2 hover:tw-underline"
      >
        + Create new brand (opens Brand Manager)
      </Link>
    </>
  );
}
